<ng-container>
  <div *ngIf="exercise" 
    class="exercise__puzzle view__type__{{ viewType }} exercise__type__{{ exercise?.type }}"
    [class.exercise_for_rus]="exercise.subject_pk === 2 || exercise?.theme_pk === 24 || exercise?.theme_pk === 30">
      <span *ngIf="index >= 0 && viewType !== 'print'" class="exercise__puzzle__number">{{index + 1}}.</span>
      <div class="exercise__puzzle__example exercise__type__{{ exercise?.type }}__{{ viewType }}"
        [class.cells]="!exercise.answers && !exercise.text && exercise.subject_pk !== 4 || exercise.theme_pk === 24"
        [class.pictography]="exercise.subject_pk === 4"
        [class.for-student]="viewType === 'student_left' || viewType === 'student_right'"
        [class.for-student_right]="viewType === 'student_right'"
        [class.for-student_left]="viewType === 'student_left'">
        <div *ngIf="showHint" class="exercise_hint"
          [ngStyle]="{'color': isCorrectAnswer() ? 'green' : !isFinishCard ? '' : 'red'}"
        >{{exercise?.hint}}</div> 
        <span class="exercise__puzzle__example__img" 
          [class.for-cell-point]="exercise.hint && exercise.hint.includes('Укажи точку') && viewType === 'print'">
          <img class="exercise__puzzle__example__img__data" src="{{ exercise.img }}" alt=""
            [ngStyle]="getCustomStyle()">
          <span *ngIf="exercise.subject_pk === 2 && exercise.text && !exercise.answers && !exercise.answers.length || exercise.subject_pk === 4 && exercise.text && !exercise.answers && !exercise.answers?.length"
            class="exercise_for_rus__text" [outerHTML]="exercise.text"></span>
          <div *ngIf="exercise.questions && exercise.questions.length" class="exercise_question">
            <span class="exercise__puzzle__task">{{exercise?.questions[0].text}}</span>
          </div>
          <span *ngIf="exercise.subject_pk === 2 && exercise.text && exercise.answers && exercise.answers.length" class="exercise__puzzle__task">
            <span class="exercise_for_rus__text" [outerHTML]="exercise.text"></span>

            <span *ngIf="exercise.subject_pk === 2 && viewType !== 'teacher' && viewType !== 'result_modal' && viewType !== 'student_left' && exercise.answers"
              class="exercise__puzzle__example__for-answer"></span>
            <span *ngIf="exercise.subject_pk === 2 && viewType !== 'teacher' && viewType !== 'result_modal' && viewType !== 'student_left' && exercise.answers"
              class="exercise__puzzle__example__for-answer"></span>
          </span>
        </span>
        <span *ngIf="!includeAnswerViewTypes.includes(viewType) && exercise.subject_pk !== 2 && exercise.answers && viewType !== 'student_left'"
          class="exercise__puzzle__example__for-answer"></span>
        <span *ngIf="
          !exercise.answers && !exercise.text && viewType !== 'teacher' && viewType !== 'result_modal' && viewType !== 'analytics_modal' && exercise.subject_pk !== 4 || 
          exercise.theme_pk === 24 && viewType === 'print' ||
          exercise.theme_pk === 24 && viewType === 'template'" 
          class="cells__table">
          <table>
            <tr *ngFor="let row of rowsForExercise">
              <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
              <td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
          </table>
        </span>
        <span *ngIf="includeAnswerViewTypes.includes(viewType) && correctAnswers && correctAnswers.length > 0"
          class="exercise__puzzle__example__input">
          <input [formControl]="answerControl" type="text"
            class="exercise__puzzle__example__input__element"
            [class.for-student-answer]="viewType === 'student_right'"
            [class.true]="viewType !== 'student_right' ? checkAnswer() : false"
            [class.result-modal]="viewType === 'result_modal'"
            (change)="changeAnswer()"
            [class.false]="viewType !== 'student_right' ? !checkAnswer() : false">
          <span *ngIf="isAuthorCard && isAccessCard || viewType === 'student_right'"
            (click)="clearAnswer()"
            class="exercise__puzzle__example__input__clear">x</span>
        </span>
        <span *ngIf="!exercise.answers && viewType === 'teacher'" class="cells__answer">
          <mat-checkbox [checked]="correctAnswerCheckbox" (change)="correctAnswerCheckbox = !correctAnswerCheckbox; changeAnswer()">
            {{ correctAnswerCheckbox ? 'Верно' : 'Неверно' }}
          </mat-checkbox>
        </span>
        <span *ngIf="!exercise.answers && viewType === 'result_modal'" class="cells__answer">
          {{ studentAnswer?.correct ? 'Верно' : 'Неверно' }}
        </span>
      </div>
  </div>

  <div class="keyboard" *ngIf="viewType === 'student_right' && exercise">
    <div class="keyboard-container">
      <ul>
        <li class="keyboard-item" *ngFor="let button of buttons">
          <a (click)="keyboardClicked(button)" appDisTouchmove>
            {{ button }}
          </a>
        </li>
        <li class="keyboard-item" *ngIf="exercise?.type == sequence">
          <a (click)="keyboardClicked(',')" appDisTouchmove>
            ,
          </a>
        </li>
        <li class="keyboard-item" *ngIf="exercise?.type == sequence">
          <a (click)="keyboardClicked(' ')" appDisTouchmove>
            &nbsp;
          </a>
        </li>
        <li class="keyboard-item">
          <a (click)="keyboardClicked(0)" appDisTouchmove>
            0
          </a>
        </li>
        <!-- <li class="keyboard-item impty"><a></a></li> -->
        <ng-container *ngIf="exercise?.text && exercise?.text.includes('спичк') || exercise?.hint && exercise?.hint.includes('спичк')">
          <li class="keyboard-item" *ngFor="let button of ['+', '-', '×', '/', '=']">
            <a (click)="keyboardClicked(button)" appDisTouchmove>
              {{ button }}
            </a>
          </li>
          <li class="keyboard-item">
          <a (click)="keyboardClicked(' ')" appDisTouchmove>
            __
          </a>
        </li>
        </ng-container>
        <li class="keyboard-item enter">
          <a (click)="changeAnswer()" appDisTouchmove>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
